import React, { useState, useRef } from 'react';
import { connect } from 'react-redux';
import { Formik, Form, Field } from 'formik';
import { Form as bootStrapForm, Col, Button, Spinner } from 'react-bootstrap';
import { feedbackOptions } from '../../configs/dropdownOptions';
import { hideModal } from '../../actions/modalsActions';
import CyberSecurity from '../../apis/cyberSecurityData';
import ReCAPTCHA from "react-google-recaptcha";
import * as yup from 'yup';

const schema = yup.object({
    feedbackCategory: yup.string().required(),
    firstName: yup.string().max(600).matches(/^[ A-Za-z0-9_.&?!',-\/()]*$/, 'Only Characters and Numbers Allowed').required(),
    lastName: yup.string().max(600).matches(/^[ A-Za-z0-9_.&?!',-\/()]*$/, 'Only Characters and Numbers Allowed').required(),
    email: yup.string().matches(/^[ A-Za-z0-9_.@&?!',-\/()]*$/, 'Please enter a valid Email Address').email('Please enter a valid Email Address').required(),
    // phone: yup.string().max(20).matches(/^[0-9+-]+$/, 'Only Phone Numbers are Allowed'),
    message: yup.string().max(600).matches(/^[ A-Za-z0-9_.&?!’:',-\/()\n]*$/, 'Only Characters and Numbers Allowed').required(),
});

function SpecificFeedbackForm(props) {
    const [updated, setUpdated] = useState(false)
    const [submitting, setSubmitting] = useState(false);
    const [recaptcha, setRecaptcha] = useState(false);
    const [viewRecaptcha, setViewRecaptcha] = useState(false);

    const renderTextField = ({ field, form, meta, checkHidden }, label) => {
        return (
            <bootStrapForm.Group>
                {/* <bootStrapForm.Label>{label}</bootStrapForm.Label> */}
                <bootStrapForm.Control isInvalid={meta.touched && meta.error} {...field} type="text" placeholder={label} />
                {meta.touched && meta.error && <div className="error" style={{ color: '#ff4040' }}>{meta.error}</div>}
            </bootStrapForm.Group>
        )
    }

    const renderTextAreaField = ({ field, form, meta }, label) => {
        return (
            <bootStrapForm.Group >
                {/* <bootStrapForm.Label>Expertise</bootStrapForm.Label> */}
                <Col className="px-0" sm={12}>
                    <bootStrapForm.Control isInvalid={meta.error} {...field} as="textarea" type="textarea" placeholder={label} style={{ height: 100 }} />
                    {meta.touched && meta.error && <div className="error" style={{ color: '#ff4040' }}>{meta.error}</div>}
                </Col>
            </bootStrapForm.Group>
        )
    }

    const renderDropDown = ({ field, form, meta, checkHidden }, label, dropdownOptions) => {
        return (
            <bootStrapForm.Group controlId="formGrid">
                <bootStrapForm.Label>{label}</bootStrapForm.Label>
                <bootStrapForm.Control isInvalid={meta.touched && meta.error} as="select" {...field} type="select" placeholder={label}>
                    <option value="">{label}</option>
                    {dropdownOptions.map(el => <option key={el} value={el}>{el}</option>)}
                </bootStrapForm.Control>
                {meta.touched && meta.error && <span style={{ color: 'red' }}>{meta.error}</span>}
            </bootStrapForm.Group>
        )
    }

    const onRecaptchaChange = (value) => {
        setRecaptcha(value)
    }

    return (
        <Formik
            validationSchema={schema}
            // validate={values => validate(values)}
            onSubmit={async (values, { resetForm }) => {
                if (recaptcha) {
                    try {
                        const response = await CyberSecurity.post('/specificfeedback', values);
                        props.hideModal();

                    } catch (error) {
                        console.log(error.message)
                    }
                }
            }}
            initialValues={{
                feedbackCategory: '',
                firstName: props.currentUser.firstName || '',
                lastName: props.currentUser.lastName || '',
                email: props.currentUser.email || '',
                // phone: props.currentUser.phone || '',
                message: '',
            }}
        >
            {({
                handleSubmit,
                handleChange,
                handleBlur,
                values,
                touched,
                isValid,
                errors,
                validateField,
                isSubmitting
            }) => (
                <Form autoComplete="off" className="px-3">
                    <div className="row">
                        <div className="col-md-12">
                            <Field name="feedbackCategory">
                                {({ field, form, meta }) => renderDropDown({ field, form, meta }, 'Choose Feedback Category', feedbackOptions())}
                            </Field>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-6 pr-md-2">
                            <Field name="firstName">
                                {({ field, form, meta }) => renderTextField({ field, form, meta }, 'First Name*')}
                            </Field>
                        </div>
                        <div className="col-md-6 pl-md-2">
                            <Field name="lastName">
                                {({ field, form, meta }) => renderTextField({ field, form, meta }, 'Last Name*')}
                            </Field>
                        </div>
                    </div>

                    <Field name="email">
                        {({ field, form, meta }) => renderTextField({ field, form, meta }, 'Email*')}
                    </Field>

                    <Field name="message">
                        {({ field, form, meta }) => renderTextAreaField({ field, form, meta }, 'Please share your thoughts*')}
                    </Field>

                    <div className="row">
                        <div className="col-md-12">
                            <div className="d-flex flex-column justify-content-center  align-items-center pb-4">
                                {viewRecaptcha && !recaptcha && <span style={{ color: 'red' }}>Please verify that you are human</span>}

                                {viewRecaptcha && <ReCAPTCHA
                                    sitekey="6Lc0_uEUAAAAAE29L9BpPI5PZMN6q2J67R4SN9Hj"
                                    onChange={onRecaptchaChange}
                                />}
                                <div className="d-flex">
                                    <Button variant="outline-primary" size="md" onClick={() => props.changeActiveSection('menu')} className="mt-4 mr-2">
                                        Back
                                        </Button>
                                    <Button variant="primary" type="submit" size="md" onClick={() => setViewRecaptcha(true)} className="mt-4">
                                        Submit
                                        {submitting ? <Spinner className="ml-3" as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : null}
                                    </Button>

                                </div>
                            </div>
                            <h3 className={`mt-3 ${updated && isValid ? null : 'd-none'}`} style={{ color: 'white' }} >Message Sent</h3>
                        </div>
                    </div>
                </Form>
            )}
        </Formik>
    );
}

const mapStateToProps = (state) => {
    return {
        currentUser: state.currentUser,
        accessToken: state.accessToken
    }
}

export default connect(mapStateToProps, { hideModal })(SpecificFeedbackForm);
